import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  setPaperId,
  setPlannerDetails,
  setSelectedSetId,
  setTestDetails,
  setTestId,
  setTestType,
} from "../../../redux/exam/examSlice";
import userTestsExercisesAction from "../../../redux/user_tests_exercises/action";
import userActivityActions from "../../../redux/user_activity/action";
import { navigateFromPracticeOrigin } from "../../../custom_utilities/dashboardBannerNavigation";
import { DASHBOARD_HOME_PATH } from "../../DashboardLayout/dashboardNavigation";
import { buildExamResumeContext } from "../utils/resumeTestUtils";
import { buildResumeVideoNavigationPayload } from "../utils/resumeUtils";

export const useResumeItemNavigation = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { testType, plannerDetails, testDetails } = useSelector((state) => state.examSlice);

  return useCallback(
    (item) => {
      if (!item) return;

      if (item.type === "video") {
        if (!item.payload) return;
        dispatch(
          userActivityActions.setVideoData(buildResumeVideoNavigationPayload(item.payload))
        );
        navigateFromPracticeOrigin(history, "/videos", {
          returnTo: DASHBOARD_HOME_PATH,
        });
        return;
      }

      const payload = item.payload || {};
      const resumeKind = payload.resumeKind || item.type;

      if (resumeKind === "legacy_exam") {
        if (!payload.raw) return;
        dispatch(userTestsExercisesAction.setUserTestsData(payload.raw));
        navigateFromPracticeOrigin(history, "/exam_test", {
          returnTo: DASHBOARD_HOME_PATH,
        });
        return;
      }

      if (resumeKind === "exam") {
        const context = buildExamResumeContext(payload);
        const paperType =
          context.paperType ?? testDetails?.paperType ?? testType?.id ?? plannerDetails?.id;
        if (!paperType) return;
        if (!context.paperId && !context.testId && !context.setId) return;

        const resumeContext = {
          ...context,
          paperType,
          plannerId: context.plannerId ?? plannerDetails?.planner_id ?? null,
          plannerTypeId: context.plannerTypeId ?? plannerDetails?.planner_type_id ?? null,
          categoryId: context.categoryId || plannerDetails?.category_id || "",
        };

        dispatch(
          setPlannerDetails({
            id: resumeContext.paperType,
            planner_id: resumeContext.plannerId,
            planner_type_id: resumeContext.plannerTypeId,
            category_id: resumeContext.categoryId || "",
          })
        );
        dispatch(setTestType({ id: resumeContext.paperType }));

        if (resumeContext.testId != null) {
          dispatch(setTestId(resumeContext.testId));
        }
        if (resumeContext.paperId != null) {
          dispatch(setPaperId(resumeContext.paperId));
        }
        if (resumeContext.setId != null) {
          dispatch(setSelectedSetId(resumeContext.setId));
        }

        dispatch(
          setTestDetails({
            ...resumeContext,
            planner_test_id: resumeContext.testId ?? resumeContext.paperId ?? null,
            redirectedFrom: "study_dashboard",
            returnTo: DASHBOARD_HOME_PATH,
          })
        );

        navigateFromPracticeOrigin(history, {
          pathname: "/test",
          state: {
            paperId: resumeContext.paperId,
            paperType: resumeContext.paperType,
            testId: resumeContext.testId,
            setId: resumeContext.setId ?? null,
            isResume: true,
            returnTo: DASHBOARD_HOME_PATH,
          },
        });
      }
    },
    [dispatch, history, plannerDetails, testDetails, testType]
  );
};
